// extracted by mini-css-extract-plugin
export default {"container":"ShowError_container__czACI","content":"ShowError_content__3kN-n"};